import { NgModule, CUSTOM_ELEMENTS_SCHEMA, provideZoneChangeDetection } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { AppRoutingModule } from "./app-routing.module";

import {
    AppComponent,
    ConfigService,
    EcsSaasLcpNgCrudUiModule
} from "esz-saas-lcp-ng-crud-ui";

import { CustomConfigService } from "./lnf/app.config.service";
import { TenantInterceptor } from "./core/interceptor/tenant.interceptor";

import { WsMainComponent } from "./view/ws-main/ws-main.component";
import { WsHomepageComponent } from './view/ws/pages/ws-homepage/ws-homepage.component';
import { WsTopbarComponent } from "./view/ws/ws-topbar/ws-topbar.component";
import { WsFooterComponent } from "./view/ws/ws-footer/ws-footer.component";
import { WsAboutusComponent } from "./view/ws/pages/ws-aboutus/ws-aboutus.component";
import { WsContactComponent } from "./view/ws/pages/ws-contact/ws-contact.component";
import { WsServicesComponent } from "./view/ws/pages/ws-services/ws-services.component";
import { WsFreeSoftwareComponent } from "./view/ws/pages/ws-free-software/ws-free-software.component";
import { WsSnapcartComponent } from "./view/ws/pages/ws-snapcart/ws-snapcart.component";
import { WsPrivacyComponent } from "./view/ws/pages/ws-privacy/ws-privacy.component";
import { WsTermsComponent } from "./view/ws/pages/ws-terms/ws-terms.component";

@NgModule({
    imports: [
        EcsSaasLcpNgCrudUiModule,
        AppRoutingModule,
        FormsModule,
    ],
    declarations: [
        WsMainComponent,
        WsTopbarComponent,
        WsFooterComponent,
        WsHomepageComponent,
        WsAboutusComponent,
        WsContactComponent,
        WsServicesComponent,
        WsFreeSoftwareComponent,
        WsSnapcartComponent,
        WsPrivacyComponent,
        WsTermsComponent
    ],

    providers: [
        // Angular 21 runs zoneless unless told otherwise: without this, an HTTP callback that sets a
        // field (contact / newsletter success and error states) never re-renders until some other
        // template event fires. The crud-ui shell was written for zone-based change detection.
        provideZoneChangeDetection(),
        { provide: ConfigService, useClass: CustomConfigService },
        { provide: HTTP_INTERCEPTORS, useClass: TenantInterceptor, multi: true },
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
